/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  ListUnmatchedPhoneCallsParams,
  PhoneCallList
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Calls no client could be chosen for, newest first.
 *
 * Admins see the firm's; anyone else sees only calls on their own line.
 * @summary List Unmatched Phone Calls
 */
export const listUnmatchedPhoneCalls = (
    params?: ListUnmatchedPhoneCallsParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<PhoneCallList>(
      {url: `/phone/calls/unmatched`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListUnmatchedPhoneCallsQueryKey = (params?: ListUnmatchedPhoneCallsParams,) => {
    return [
    `/phone/calls/unmatched`, ...(params ? [params] : [])
    ] as const;
    }


export const getListUnmatchedPhoneCallsQueryOptions = <TData = Awaited<ReturnType<typeof listUnmatchedPhoneCalls>>, TError = HTTPValidationError>(params?: ListUnmatchedPhoneCallsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listUnmatchedPhoneCalls>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUnmatchedPhoneCallsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUnmatchedPhoneCalls>>> = ({ signal }) => listUnmatchedPhoneCalls(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUnmatchedPhoneCalls>>, TError, TData> & { queryKey: QueryKey }
}

export type ListUnmatchedPhoneCallsQueryResult = NonNullable<Awaited<ReturnType<typeof listUnmatchedPhoneCalls>>>
export type ListUnmatchedPhoneCallsQueryError = HTTPValidationError


/**
 * @summary List Unmatched Phone Calls
 */

export function useListUnmatchedPhoneCalls<TData = Awaited<ReturnType<typeof listUnmatchedPhoneCalls>>, TError = HTTPValidationError>(
 params?: ListUnmatchedPhoneCallsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listUnmatchedPhoneCalls>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListUnmatchedPhoneCallsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






